import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { useCallback } from 'react';
import { useUncontrolled } from '../../hooks/useUncontrolled.js';
import { Checkbox } from './Checkbox.js';
import { CheckboxGroupContext } from './context/CheckboxGroup.context.js';
import defaultStyles from './styles/Checkbox.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { isArray, isObject } from '../../utils/is.js';

const ID_SUFFIX = '_checkbox_group';
const CheckboxGroup = props => {
  const {
    disabled,
    options,
    theme,
    validationStatus,
    children,
    direction = 'horizontal',
    name = 'checkbox',
    size,
    onChange,
    dataTestId,
    defaultValue,
    value,
    idSuffix = ID_SUFFIX
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const [_value, setValue] = useUncontrolled({
    value,
    defaultValue,
    fallbackValue: [],
    onChange
  });
  const checkboxGroupClasses = clsx(styles.group, {
    [styles.error]: validationStatus === 'error',
    [styles.vertical]: direction === 'vertical',
    [styles.horizontal]: direction === 'horizontal'
  });
  const handleOnChange = useCallback(event => {
    const itemValue = event.currentTarget.value;
    setValue(_value.includes(itemValue) ? _value.filter(item => item !== itemValue) : [..._value, itemValue]);
  }, [_value, setValue]);
  return /*#__PURE__*/jsx("div", {
    className: checkboxGroupClasses,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/jsx(CheckboxGroupContext.Provider, {
      value: {
        isCheckboxGroup: true,
        checkboxGroupValue: _value,
        onGroupChange: handleOnChange,
        disabled,
        name: `${name}[]`,
        idSuffix
      },
      children: isArray(options) ? options.map((option, index) => {
        const label = isObject(option) ? option.label : option;
        const checkValue = isObject(option) ? option.value : option;
        return /*#__PURE__*/jsx(Checkbox, {
          size: size,
          name: name,
          disabled: disabled || isObject(option) && option.disabled,
          value: checkValue,
          label: label,
          theme: theme,
          idSuffix: idSuffix + index
        }, checkValue);
      }) : children
    })
  });
};
CheckboxGroup.displayName = 'CheckboxGroup';

export { CheckboxGroup };
